import { render, staticRenderFns } from "./order-details-modal.vue?vue&type=template&id=1fa54dc2&"
import script from "./order-details-modal.vue?vue&type=script&lang=js&"
export * from "./order-details-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports